module.exports = __webpack_public_path__ + "static/media/20.e39da86a.jpg";